const createStore = require("@cirrus/legacy/app-common/framework/utils/createStore.es6").default

let _zoom = 0

function CalculateFonts(element) {
  element.each(function () {
    const element = $(this)
    const size = parseInt(element.attr("data-font-size"))
    if (size)
      element.css({
        "font-size": Math.max(size + _zoom, 0) + "px",
      })
  })
}

function CalculateIFrameFont() {
  const scope = $("div.container iframe").contents()
  const editor = scope.find("body").add($('[data-region="answer-region"] .cke_wordcount *'))
  const size = editor.data("font-size")
  editor.css("font-size", Math.max(size + 3 + _zoom, 0) + "px", "!important")
}

function CalculateLineHeight() {
  const questionCard = $('[data-region="question-content"] #question-card')
  const radio = questionCard.find(".radio-label span")
  const checkbox = questionCard.find(".checkbox-label span")
  const orderItems = questionCard.find(".order-items .sortable *")
  const scoreReportPage = $(".scoreReportPage")

  const questionContent = questionCard.add(radio).add(checkbox).add(scoreReportPage).add(orderItems)

  questionContent.css({
    "line-height": "normal",
  })
}

export const AccessibilityStore = createStore("AccessibilityStore", {
  getState () {
    return {
      zoom: _zoom,
      theme: "",
    }
  },
  handlers: {
    ACCESSIBILITY_ZOOM_IN: "zoomIn",
    ACCESSIBILITY_ZOOM_OUT: "zoomOut",
    ACCESSIBILITY_ZOOM_RESET: "zoomReset",
  },
  init () {
    $("header .accessibility").click(() => {
      $("#modal-accessibility").modal("show")
    })
    $("#modal-accessibility div[data-id=theme]").click(function () {
      document.body.className = document.body.className.replace(/\w*-theme(\b|$)/, "")
      document.body.className += " " + this.className //$(this.options[this.selectedIndex]).attr('class');
      //save theme

      $.ajax({
        type: "POST",
        url: Url.api("/api/user/save-theme") + "?theme=" + this.className,
      })
    }) //   CalculateFonts($('.container *, #modal-region, #modal-region *'));
  },
  calculateFonts (element) {
    CalculateFonts(element)
    CalculateLineHeight()
  },
  CalculateIFrameFont (element) {
    CalculateIFrameFont(element)
  },
  zoomIn () {
    if (_zoom < 6) {
      _zoom++
      CalculateFonts(
        $(
          ".container *, #system-notifications, #pause-exam-region, #modal-region *, .calculator-popup *",
        ),
      )
      CalculateLineHeight()

      if ($("div.container iframe").contents().length > 0) CalculateIFrameFont() //localStorage.setItem("zoom", _zoom);

      this.__emitChange()

      App.vent.trigger("window:resize")
    }
  },
  zoomOut () {
    if (_zoom > -2) {
      _zoom--
      CalculateFonts(
        $(
          ".container *, #system-notifications, #pause-exam-region, #modal-region *, .calculator-popup *",
        ),
      )
      CalculateLineHeight()

      if ($("div.container iframe").contents().length > 0) CalculateIFrameFont() //localStorage.setItem("zoom", _zoom);

      this.__emitChange()

      App.vent.trigger("window:resize")
    }
  },
  zoomReset () {
    _zoom = 0
    CalculateFonts(
      $(
        ".container *, #system-notifications, #pause-exam-region, #modal-region *, .calculator-popup *",
      ),
    )
    CalculateLineHeight()

    if ($("div.container iframe").contents().length > 0) CalculateIFrameFont()
    //localStorage.setItem("zoom", _zoom);
    this.__emitChange()

    App.vent.trigger("window:resize")
  },
})
